import { IComboBoxOption } from "@fluentui/react";
import { IPanelRazonEliminar } from "./PanelRazonEliminar";
import { IRazonEdit, IRazonEiminar } from "../../../../../Interfaces/auxiliar/IRazon";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { useEffect, useState } from "react";
import { RazonService } from "../../../../../services/auxiliar/RazonService";

export const UsePanelRazonEliminar=(props:IPanelRazonEliminar)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [contentShow, setcontentShow] = useState(true);
    const [loadprogress, setloadprogress] = useState(false);

    const initial:IRazonEdit={
        codigo: "",
        descripcion: "",
        estadoId: "",
        razonId: ""
    }
     const reset=()=>{
         setMensaje("")
         setRequest(initial)
         setStatus(0)
         props.onDismiss()
     }
     useEffect(()=>{
        if(props.item!=initial){
          setRequest({...request,codigo:props.item.codigo,descripcion:props.item.descripcion,
            estadoId:props.item.estadoId,razonId:props.item.razonId})
          }
      },[props.item])
      const [request,setRequest]=useState<IRazonEdit>(initial)
      const deleteRazon=()=>{
        setLoading(true)
        const eliminar:IRazonEiminar={
            razonId: request.razonId
        }
        RazonService.EliminarRazon(eliminar).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setloadprogress(true);
                setcontentShow(false);
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                  props.reload?.();
                  reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,deleteRazon,loading,reset,mensaje,status, contentShow, loadprogress}

}